import { render, staticRenderFns } from "./sk-radio-img-wap.vue?vue&type=template&id=75c01bbb&scoped=true&"
import script from "./sk-radio-img-wap.vue?vue&type=script&lang=js&"
export * from "./sk-radio-img-wap.vue?vue&type=script&lang=js&"
import style0 from "./sk-radio-img-wap.vue?vue&type=style&index=0&id=75c01bbb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c01bbb",
  null
  
)

export default component.exports